import {
  DialogContent,
  Dialog,
  DialogTitle,
  DialogActions,
  Typography,
  Button,
} from "@mui/material";
import "../i18n/config";
import { GroupMember } from "../types/gigya";
import { useTranslation } from "react-i18next";

type ModalLeaveTeamProps = {
  member: GroupMember | undefined;
  isOpen: boolean;
  close: () => void;
  deleteMember: () => void;
  groupId: string;
};

export const ModalLeaveTeam = (props: ModalLeaveTeamProps) => {
  const { member, isOpen, close, deleteMember } = props;
  const { t } = useTranslation();

  return (
    <>
      {member && (
        <Dialog
          sx={{ zIndex: 200000 }}
          PaperProps={{ style: { height: "250px" } }}
          open={isOpen}
          onClose={close}
        >
          <DialogTitle>
            <Typography>{t("leaveTeam")}</Typography>
          </DialogTitle>
          <DialogContent style={{ paddingTop: "4px" }}>
            <Typography key={0}>{t("leaveTeamBody")}</Typography>
            <Typography key={1}>{t("leaveTeamWarning")}</Typography>
          </DialogContent>
          <DialogActions style={{ padding: "0 24px" }}>
            <Button key={0} variant="text" onClick={close}>
              {t("exported.Cancel")}
            </Button>
            <Button key={1} variant="text" onClick={deleteMember}>
              {t("leaveTeam")}
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </>
  );
};

export default ModalLeaveTeam;
